import { useState, useEffect } from 'react';
import './App.css';
import AboutSection from './components/AboutSection';
import './components/AboutSection.css';
import Footer, { FooterMeta } from './components/Footer';
import './components/Footer.css';
import Essays from './components/Essays';
import SEOHead from './components/SEOHead';
import { Analytics } from '@vercel/analytics/react';

function App() {
  const [currentPage, setCurrentPage] = useState(() => {
    return window.location.hash === '#essays' ? 'essays' : 'home';
  });

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(window.location.hash === '#essays' ? 'essays' : 'home');
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  if (currentPage === 'essays') {
    return (
      <>
        <SEOHead />
        <Essays />
        <Analytics />
      </>
    );
  }

  return (
    <>
      <SEOHead />
      <div className="App">
        <a href="#essays" className="essays-nav-link">Essays</a>
        <main className="main-screen" role="main">
          <header className="name-container">
            <div className="name-row">
              <h1 className="name">Sidharth Sudhir</h1>
              <img src="/pfp.jpeg" alt="Sidharth Sudhir" className="profile-pic" />
            </div>
            <p className="location">blr, la, nyc</p>
          </header>

          <section className="content-container">
            <div className="section">
              <div className="about-container">
                <AboutSection />
              </div>
              <Footer />
            </div>
          </section>
          <FooterMeta />
        </main>
        <Analytics />
      </div>
    </>
  );
}

export default App;
